import { WidgetType } from 'common/models/widget.model';

export enum SupportedWidgetRenderType {
  Bar = 'bar',
  Sankey = 'sankey',
  Wordcloud = 'wordcloud',
  Doughnut = 'doughnut',
  Pie = 'pie',
  Line = 'line',
  Geography = 'geography',
  Elsie = 'elsie',
}

export const widgetPptType: { [key: string]: SupportedWidgetRenderType } = {
  [WidgetType.BAR_CHART]: SupportedWidgetRenderType.Bar,
  [WidgetType.WORD_CLOUD]: SupportedWidgetRenderType.Wordcloud,
  [WidgetType.ALIGNMENT_MOVEMENT]: SupportedWidgetRenderType.Sankey,
  [WidgetType.RESPONSE_VOLUME]: SupportedWidgetRenderType.Doughnut,
  [WidgetType.RESPONSE_VOLUME_OVER_TIME]: SupportedWidgetRenderType.Line,
  [WidgetType.RESPONSE_GEO]: SupportedWidgetRenderType.Geography,
  [WidgetType.ALIGNMENT_DISTRIBUTION]: SupportedWidgetRenderType.Bar,
  [WidgetType.RESPONSE_OVER_TIME_RESPONSES]: SupportedWidgetRenderType.Line,
  [WidgetType.LATEST_ALIGNMENT]: SupportedWidgetRenderType.Line,
  [WidgetType.ELSIE_AI_EXPORT]: SupportedWidgetRenderType.Elsie,
};
